import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'valueArrayFilter',
    pure: false
})
export class ValueArrayFilterPipe implements PipeTransform {
  transform(items: any[], filter: Object): any {
    if (!items || !filter) {
      return items;
    }

    return items.filter(item => (item[filter['propertyToFilter']] === filter['valueToFilter']) && !item.isPropertyHidden);
  }
}
